<div class="row mh-100">
    <div class="col-md-5 mx-auto p-2 p-md-5">
        <div class="card bg-light border-0 rounded-3">
            <div class="card-body">
                <div class="text-center">
                    <img class="mb-3 logo" src="/assets/logo.png"><br>
                    <div>
                        Welcome to Trial Demo MFGM Executive Function Test
                    </div>
                    <div>Please login or signup to continue</div>
                </div>
                <div class="row">
                    <form class="p-3 col-12" [formGroup]="loginForm" #thisForm="ngForm" (ngSubmit)="submitForm(loginForm)" novalidate>
                        <div class="form-floating mb-4">
                            <input type="email" formControlName="email" [class.is-invalid]="loginForm.get('email')?.invalid && (thisForm.submitted || loginForm.get('email')?.touched)" placeholder="name@example.com" class="form-control" required>
                            <label>Email</label>
                            <div class="text-danger position-absolute w-100" *ngIf="loginForm.get('email')?.invalid && (thisForm.submitted || loginForm.get('email')?.touched)">
                                <small class="small" *ngIf="loginForm.get('email')?.errors?.required">Type your email</small>
                                <small *ngIf="loginForm.get('email')?.errors?.email">Email is not valid</small>
                                <small *ngIf="loginForm.get('email')?.errors?.serverError">{{loginForm.get('email')?.errors?.serverError}}</small>
                            </div>
                        </div>
                        <div class="form-floating mb-4 position-relative">
                            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" [class.is-invalid]="loginForm.get('password')?.invalid && (thisForm.submitted || loginForm.get('password')?.touched)" placeholder="Password" class="form-control" required>
                            <button class="btn position-absolute end-0 top-0 h-100 me-3 border-0 outline-0 shadow-none" type="button" (click)="showPassword=!showPassword" tabindex="-1">
                                <i class="material-icons">
                                    {{showPassword ? 'visibility' : 'visibility_off'}}
                                </i>
                            </button>
                            <label>Password</label>
                            <div class="text-danger position-absolute w-100" *ngIf="loginForm.get('password')?.invalid && (thisForm.submitted || loginForm.get('password')?.touched)">
                                <small *ngIf="loginForm.get('password')?.errors?.required">Type your password</small>
                                <small *ngIf="loginForm.get('password')?.errors?.serverError">{{loginForm.get('password')?.errors?.serverError}}</small>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-between mb-4">
                            <div class="col-md-4 col-sm-12">
                                <button type="submit" [attr.disabled]="loading.status?'disabled':null" class="btn btn-primary py-2 px-4 w-100">
                                    Login
                                </button>
                            </div>
                            <div class="col-md-4 col-sm-12 mt-md-0 mt-3 text-center text-md-end d-md-flex align-items-center justify-content-end">
                                <a [class.disabled]="loading.status" class="btn-link text-nowrap text-warning" routerLink="/forgot-password">
                                    Forgot password?
                                </a>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="mb-2">Don't have an account?</div>
                            <div>
                                <a [class.disabled]="loading.status" class="btn btn-secondary text-light py-2 px-5" routerLink="/signup">
                                    Signup
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="showNotification" class="success d-flex justify-content-center align-items-center position-fixed w-100 h-100">
    <div class="card bg-light text-dark fw-bold">
        <div class="card-body">
            <div class="text-center p-3">
                <div class="alert alert-success">
                    Congratulations your account is active, please login to continue.
                </div>
                <p>
                    <button (click)="closeNotification()" class="btn btn-primary w-100 text-white">
                        Login
                    </button>
                </p>
            </div>
        </div>
    </div>
</div>
